import {
  TARIFF_LOADING,
  TARIFF_ERROR,
  TARIFF_GET_LIST,
  TARIFF_RESET_LIST,
  TARIFF_ADD,
  TARIFF_GET_IMAGE,
} from "actions/chargers/tariff/constants";

const initialState = {
  loading: false,
  errors: [],

  tariffList: [],
  tariffImage: ""
};

export default function (state = initialState, action) {
  let tariffList,
    index;
  switch (action.type) {
    case TARIFF_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case TARIFF_ERROR:
      return {
        ...state,
        errors: action.payload.content
      };
    case TARIFF_GET_LIST:
      return {
        ...state,
        loading: false,
        tariffList: action.payload.content
      };
    case TARIFF_RESET_LIST:
      return {
        ...state,
        tariffList: []
      };
    case TARIFF_ADD:
      tariffList = Object.assign([], state.tariffList);
      index = tariffList.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        tariffList[index] = action.payload;
      } else {
        tariffList.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        tariffList
      };
    case TARIFF_GET_IMAGE:
      return {
        ...state,
        loading: false,
        tariffImage: action.payload.content
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chargers/tariffReducer.js